import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue' // <-- Import nextTick
import '../assets/css/styles.css'
import HomeOne from '@/views/home/home-one.vue'
import AboutUs from '@/views/inner-page/about-us.vue'
import OpretWebshop from '@/views/inner-page/opret-webshop.vue'
import ContactUs from '@/views/inner-page/contact-us.vue'
import PrivacyPage from '@/views/inner-page/privacy-page.vue'
import ShopStyle1 from '@/views/shop/shop-style-1.vue'
import ShopSingleV1 from '@/views/shop-detail/shop-single-v1.vue'
import ErrorPage from '@/views/special/error-page.vue'
import ShopArtist from '@/views/shop/shop-artist.vue'
import BrowseArtists from '@/views/shop/browse-artists.vue'
import BlogPage from "@/views/blog/blog-page.vue";
import BlogDetail from "@/views/blog/blog-detail.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeOne,
        meta: {
            title: 'Hjem',
            description: 'Oplev unik kunst og design fra talentfulde kunstnere på vores markedsplads.'
        }
    },

    {
        path: '/om-os',
        name: 'about-us',
        component: AboutUs,
        meta: {
            title: 'Om Os',
            description: 'Lær mere om vores mission om at forbinde kunstnere med kunstelskere.'
        }
    },
    {
        path: '/opret-webshop',
        name: 'opret-webshop',
        component: OpretWebshop,
        meta: {
            title: 'Opret Webshop',
            description: 'Er du kunstner? Opret din egen webshop på vores platform i dag.'
        }
    },
    {
        path: '/kontakt',
        name: 'contact',
        component: ContactUs,
        meta: {
            title: 'Kontakt Os',
            description: 'Har du spørgsmål? Kom i kontakt med vores team.'
        }
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyPage,
        meta: {
            title: 'Privatlivspolitik',
            description: 'Læs vores privatlivspolitik og handelsbetingelser.'
        }
    },
    {
        path: '/blog',
        name: 'blog',
        component: BlogPage,
        meta: {
            title: 'Blogindlæg',
            description: 'Læs blogindlæk på YOKO.'
        }
    },
    {
        path: '/blog/:slug',
        name: 'blogDetail',
        component: BlogDetail,
        meta: {
            title: 'Blogindlæg',
            description: 'Læs blogindlæk på YOKO.'
        }
    },

    {
        path: '/shop',
        name: 'shop',
        component: ShopStyle1,
        meta: {
            title: 'Shop',
            description: 'Gå på opdagelse i alle produkter fra vores kunstnere.'
        }
    },
    {
        path: '/shop/:category/:sub?',
        name: 'shop-category',
        component: ShopStyle1,
        props: true,
        meta: {
            title: 'Shop Kategori',
            description: 'Se produkter i denne kategori.'
        }
    },

    {
        path: '/kunstner/:artistSubdomain',
        name: 'kunstner',
        component: ShopArtist,
        props: true,
        meta: {
            title: 'Kunstnerprofil',
            description: 'Udforsk profilen og produkterne fra denne kunstner.'
        }
    },
    {
        path: '/kunstnere',
        name: 'kunstnere',
        component: BrowseArtists,
        props: true,
        meta: {
            title: 'Find Kunstnere',
            description: 'Gennemse alle de talentfulde kunstnere på vores platform.'
        }
    },
    {
        path: '/kunstnere/:brancheId',
        name: 'kunstnere-branche',
        component: BrowseArtists,
        props: true,
        meta: {
            title: 'Kunstnere efter Branche',
            description: 'Find kunstnere inden for en specifik branche.'
        }
    },

    {
        path: '/produkt/:id',
        name: 'shop-single-v1',
        component: ShopSingleV1,
        meta: {
            title: 'Produkt',
            description: 'Se detaljer om dette unikke produkt.'
        }
    },

    {
        path: '/404',
        name: '404',
        component: ErrorPage,
        meta: {
            title: '404 - Siden Ikke Fundet',
            description: 'Siden du ledte efter, kunne desværre ikke findes.'
        }
    },
    {
        // Catch-all route to redirect to 404
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    }
]

const router = createRouter({
    history: createWebHistory (),
    routes
})

const DEFAULT_SITE_TITLE = 'YOKO.dk';
const DEFAULT_DESCRIPTION = 'Oplev og køb unik kunst og design direkte fra danske kunstnere.';

router.afterEach((to) => {
    nextTick(() => {
        const pageTitle = to.meta.title ? `${to.meta.title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE;
        document.title = pageTitle;

        const pageDescription = to.meta.description || DEFAULT_DESCRIPTION;

        let descriptionEl = document.querySelector('meta[name="description"]');
        if (!descriptionEl) {
            descriptionEl = document.createElement('meta');
            descriptionEl.setAttribute('name', 'description');
            document.head.appendChild(descriptionEl);
        }
        descriptionEl.setAttribute('content', pageDescription);
    });
});

export default router